export default () => ({
    auth_token: null,
    status: 'authenticating'
})